import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'

import { cloneElement } from 'react'

import Typography from '@segment/matcha/components/Typography'
import { CheckIcon } from '@segment/matcha/components/Icons/Common'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import TabsLayoutBase, * as TabsLayout from '@segment/matcha/recipes/TabsLayout'
import useTabs from '@segment/matcha/recipes/Tabs/useTabs'

import { usePageConfig } from '@segment/contexts/page'

import data from './data'

const copy = {
  heading: `Which plan is right for you?`,
}

const WhichPlan = () => {
  const config = usePageConfig()
  const theme = useTheme()
  const { getTrackProps, getControlProps, getPanelProps, activeTabKey } = useTabs(0, data(config).length, `which-plan`)

  return (
    <SectionComponent variant="centered" id="which-plan-is-right-for-you">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <TabsLayoutBase>
          <TabsLayout.Controls {...getTrackProps()}>
            {data(config).map((tab, index) => (
              <TabsLayout.Control key={tab.key} {...getControlProps(index)}>
                {tab.title}
              </TabsLayout.Control>
            ))}
          </TabsLayout.Controls>

          {data(config).map((tab, index) => (
            <TabsLayout.Content {...getPanelProps(index)} active={index === activeTabKey} key={tab.key}>
              <TabsLayout.Copy>
                <PlanHeading variant="h4" tag="h3">
                  {tab.title} plan:
                </PlanHeading>

                <List>
                  {tab.list.map((item) => (
                    <ListItem key={item.name} checked={item.check}>
                      <CheckIcon size="small" color={theme.palette.twilio.gray[item.check ? 100 : 30]} />
                      <StyledTypography
                        variant="pMedium"
                        tokens={{ color: theme.palette.twilio.gray[item.check ? 100 : 30] }}
                      >
                        {item.name}
                      </StyledTypography>
                    </ListItem>
                  ))}
                </List>

                {tab.hint && <Typography variant="pMedium">{tab.hint}</Typography>}

                <ButtonWrapper>{cloneElement(tab.button, { expanded: true })}</ButtonWrapper>
              </TabsLayout.Copy>

              <TabsLayout.Media>{tab.image}</TabsLayout.Media>
            </TabsLayout.Content>
          ))}
        </TabsLayoutBase>
      </Section.Contents>
    </SectionComponent>
  )
}

const SectionComponent = styled(SectionBase)`
  overflow: hidden;

  ${Section.Wrapper} {
    padding-top: 120px;

    ${({ theme }) => theme.breakpoints.down(`md`)} {
      padding-top: 80px;
    }
  }
`

const PlanHeading = styled(Typography)`
  margin-top: 0;
`

const List = styled.ul`
  list-style: none;
  display: grid;
  gap: 12px;
  padding: 0;
`

const ListItem = styled.li<{ checked: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
`

const StyledTypography = styled(Typography)`
  margin: 0;
`

const ButtonWrapper = styled.div`
  margin-top: 40px;
  width: 100%;

  ${({ theme }) => theme.breakpoints.up(`sm`)} {
    width: fit-content;
  }
`

export default WhichPlan
